module.exports = __webpack_public_path__ + "img/user-dd-icon.2a576b1b.png";